import AppHeader from '../AppHeader'
export default {
  name: 'will-must-sent',
  components: {
    AppHeader
  },
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goWillMustList: function () {
      this.$router.push({path: '/will_must_list'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/will-must-sent.js